<template>
  <div>
    <!-- added spinner logic before navigating to capone -->
    <div v-if="outcome && outcome.quotation && outcome.quotation.productResults" class="spinner-container">
      <div class="spinner-background"></div>
      <div class="spinner">
        <div class="spinner-circle"></div>
      </div>
    </div>
  </div>
</template>

  <!-- commented the below lines as part of summary page removal changes -->

  <!-- <div>
    <div v-if="outcome && outcome.quotation && outcome.quotation.productResults && outcome.quotation.productResults[0].creditRequestedDecisions" > -->
      <!-- <ApprovedHeader :name="person.firstName" class="px-10 pb-10 m:px-0"/> -->
    <!-- <ApprovedHeader :name="person.firstName" :creditRequested="creditRequested" :balanceTransferRequestedDecision="outcome.quotation.productResults[0].creditRequestedDecisions[0].creditDecision" class="px-10 pb-10 m:px-0"/>
      <div class="curved-bg">
        <div class="curved"></div>
      </div>
      <div class="curved-container container max-w-5xl mx-auto px-2 md:px-6" v-if="outcome">
        <Product :class="{ '-mt-16': index === 0 }" class="mb-10" v-bind:key="product.productId" v-for="(product, index) in showSelectedProduct()" :ref-id="outcome.polReferenceId" :campaign="campaign" :pcr="pcr" :retrieval-token="outcome.quotation.retrievalToken" :agreement-url="outcome.quotation.agreementUrl" :source-code="sourcecode" :product="product"/>
      </div>
    </div>
    <div v-else-if="outcome && outcome.quotation && outcome.quotation.productResults"> -->
      <!-- <ApprovedHeader :name="person.firstName" class="px-10 pb-10 m:px-0"/> -->
    <!-- <ApprovedHeader :name="person.firstName" :creditRequested="creditRequested" :balanceTransferRequestedDecision="outcome.quotation.productResults[0].balanceTransferRequestedDecision" class="px-10 pb-10 m:px-0"/>
      <div class="curved-bg">
        <div class="curved"></div>
      </div>
      <div class="curved-container container max-w-5xl mx-auto px-2 md:px-6" v-if="outcome">
        <Product :class="{ '-mt-16': index === 0 }" class="mb-10" v-bind:key="product.productId" v-for="(product, index) in showSelectedProduct()" :ref-id="outcome.polReferenceId" :campaign="campaign" :pcr="pcr" :retrieval-token="outcome.quotation.retrievalToken" :agreement-url="outcome.quotation.agreementUrl" :source-code="sourcecode" :product="product"/>
      </div>
    </div>
    <Footer/>
  </div>
</template> -->

<script>

// commented the below import statements as part of summary page removal changes
/*import ApprovedHeader from '@/v2/components/headers/ApprovedHeader'
import Product from '@/v2/components/elements/Product'
import Footer from '@/v2/components/Footer'*/
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'Results',

  // commented the below component section as part of summary page removal changes
  /*components: {
    ApprovedHeader,
    Product,
    Footer
  },*/
  created() {
    if (!this.outcome || !this.outcome.quotation || !this.outcome.quotation.productResults) {
      this.$router.push('/')
    }else{
      this.navigateToCapOne() //function call happens when productResults is present in the capone response
    }
  },
  computed : {
    ...mapFields([
      'person',
      'internal.outcome',
      'internal.payload',
      'sourcecode',
      'balanceTransferRequestedDecision',
      'creditRequested',
      'internal.campaign',
      'internal.pcr'
    ]),
  },
  methods: {

    // commented the below functions as part of summary page removal changes
    /*orderedProducts() {

      let productId = (this.payload && this.payload.offer && this.payload.offer.productId) ? this.payload.offer.productId : null
      let products = this.outcome.quotation.productResults.slice()

      const offerCardIndex = products.findIndex(card => card.productId == productId)

      products.push(...products.splice(0, offerCardIndex))

      return products
    },
    showSelectedProduct() {

      let productId = (this.payload && this.payload.offer && this.payload.offer.productId) ? this.payload.offer.productId : null
      let products = this.outcome.quotation.productResults.slice()
      let selectedProductList = [];

      products.filter(product => product.productId == productId).forEach(card => selectedProductList.push(card))

      if(selectedProductList.length > 0) {
        return selectedProductList;
      }
      else {
        return products;
      }
    },*/

    //added a new function to auto navigate to capone when productResults is true
    navigateToCapOne() {

      let productId = (this.payload && this.payload.offer && this.payload.offer.productId) ? this.payload.offer.productId : this.outcome.quotation.productResults[0].productId

      let url = this.outcome.quotation.agreementUrl
        .replace(this.outcome.quotation.retrievalToken, encodeURIComponent(this.outcome.quotation.retrievalToken))
        .replace("PRODUCT_ID_REPLACE", productId)
        .replace("V_REPLACE", this.sourcecode);
      if (this.campaign != '') {
        url = url + `&campaign=${this.campaign}`;
      }
      if (this.pcr != '') {
        url = url + `&pcr=${this.pcr}`;
      }
      location.href = url;
    }
  }
}
</script>

<style>

/* CSS for the spinner logic */
.spinner-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7); /* Semi-transparent white background */
}

.spinner {
  position: relative;
}

.spinner-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 3px solid #ccc;
  border-top-color: #333;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

</style>
